// @ts-nocheck
 
 
 
 
 
 
 
/* eslint-disable padding-line-between-statements, import/order */
/* eslint-disable @typescript-eslint/no-unused-vars */
 
 
 
 
 
 
 
 
 
import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';

import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';


import LogsTable from './LogsTable';

const Logs: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);
  return (
    <CardContainer>
      <Switch>
        <Route exact path={`${baseURL}`}>
          <LogsTable/>
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { Logs };
